import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Chinese%20modern%20social%20media%20news%20abstract%20background%20warm%20orange%20and%20coral%20gradient%20with%20geometric%20shapes%20dynamic%20composition%20clean%20minimal%20style%20soft%20glowing%20particles%20editorial%20design%20aesthetic&width=1600&height=900&seq=hero-bg-chigua-01&orientation=landscape"
        alt="吃瓜网站线路一 - 51吃瓜网站入口"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <span className="inline-block bg-accent-500 text-background-50 text-xs font-medium px-3 py-1 rounded-full mb-6 tracking-wide">
          🎯 吃瓜网站线路一 · 实时更新
        </span>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 font-bold leading-tight max-w-4xl">
          最新吃瓜网站黑料爆料
        </h1>
        <p className="font-heading text-xl md:text-3xl lg:text-4xl text-background-50/90 mt-3 mb-2">
          网红塌房现场 · 每日大赛追踪
        </p>
        <p className="text-sm md:text-base text-background-50/70 max-w-2xl mt-4 leading-relaxed">
          聚合呈现51吃瓜网站入口、在线观看、最新黑料爆料，追踪网红塌房现场与每日大赛热点，为搜索吃瓜网址、在线吃瓜的用户提供实时内容承接。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/heiliao-baoliao"
            className="bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            立即吃瓜 <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/meiri-dasai"
            className="bg-background-50/20 text-background-50 border border-background-50/30 px-8 py-3 rounded-full text-sm font-medium hover:bg-background-50/30 transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            每日大赛 <i className="ri-fire-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}